import { Component, OnInit, Inject, ViewChild, ElementRef} from '@angular/core';
import { Router, ActivatedRoute} from '@angular/router';
import { AdminService } from '../../admin.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Options } from '@angular-slider/ngx-slider';
import { HasUnsavedChanges } from '../unsaved-changes-guard';
import {
    MatDialog,
    MAT_DIALOG_DATA,
    MatDialogRef,
  } from '@angular/material/dialog';
import {
    MatSnackBar,
    MatSnackBarHorizontalPosition,
    MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor4 } from 'ckeditor4-angular/ckeditor';

@Component({
    selector: 'app-create-competition',
    templateUrl: './create-competition.component.html',
    styleUrls: ['./create-competition.component.css']
})

export class CreateCompetition implements HasUnsavedChanges {
    @ViewChild('instruction') instructionTextarea: ElementRef;
    @ViewChild('brief') detailTextarea: ElementRef;
    public Editor = ClassicEditor;
    selectedLanguages = new FormControl('');
    languages = ["English*", "हिन्दी", "ગુજરાતી", "తెలుగు", 'मराठी'];
    numberOfentry = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    numberOfentryForm = new FormControl('');
    competitionName = "";
    selectedLanguageForShow = [];
    nameWordCont = 0;
    createCompetitionForm: FormGroup;
    value: number = 1;
    highValue: number = 12;
    options: Options = {
        floor: 1,
        ceil: 12
    };
    previewDetails = false;
    minEndDate: Date;
    maxEndDate: Date;
    times: string[] = ["09:00 am", "12:00 pm", "03:00 pm", "06:00 pm"];
    selectedEndTime: string;
    endDate = new FormControl();
    minStartDate: Date;
    maxStartDate: Date;
    selectedStartTime: string;
    startDate = new FormControl();
    horizontalPosition: MatSnackBarHorizontalPosition = 'end';
    verticalPosition: MatSnackBarVerticalPosition = 'top';
    previewPage = 1;
    photoUrl = '';
    posterUrl = ' ';
    detailsPicture = '';
    editingLanguage = 'English*';
    nameForm = 'name';
    noteForm = 'note';
    instructionForm = 'instruction'
    detailForm = 'deatailsBrief'

    toggleExpandIcon = [false, false, false, false, false];
    indianStates: any[] = [];
    selectedOption: string = "Select option";
    selectedStateCode: string = ''
    showDropdown: boolean = false;
    private unsavedChanges: boolean = true;
    isUploaded: boolean = false;
    isPortraitUploaded: boolean = false;
    fileSize: number = 1;
    portraitImageSize: number = 1;
    isPictureUploaded: boolean = false;
    selectedPictureSize: number = 1;
    toggleDropdown() {
        this.showDropdown = !this.showDropdown;
    }

    hasUnsavedChanges(): boolean {
        return this.unsavedChanges;
    }

    selectOption(option: string, code:string) {
        this.selectedOption = option;
        this.selectedStateCode =code
        this.showDropdown = false;
    }

    onClick(event: MouseEvent) {
        if (!(event.target as HTMLElement).closest('.dropdown-container')) {
            this.showDropdown = false;
        }
    }
    ngOnInit(): void {
        let competitionId = this.activatedRoute.snapshot.params.competitionUUID;
        this.selectedLanguages.setValue(["English*"]);
        this.numberOfentryForm.setValue(1);
        this.getSelectedLanguageFromFormControl();

        this.createCompetitionForm = this._formBuilder.group({
            name: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(28)]],
            deatailsBrief: ['', [Validators.required, Validators.maxLength(1000)]],
            instruction: ['', [Validators.required, Validators.maxLength(1000)]],
            note: ['', [Validators.maxLength(150)]],
            level: ['', [Validators.required]],
            selectedState: [''],
            photo: ['', [Validators.required]],
            poster: ['', [Validators.required]],
            photoName: [''],
            posterName: [''],
            startClass: [this.value, [Validators.required]],
            endClass: [this.highValue, [Validators.required]],
            startTime: ['', [Validators.required]],
            endTime: ['', [Validators.required]],
            hindiName: [''],
            gujName: [''],
            telName: [''],
            marName: [''],
            hindideatailsBrief: [''],
            gujdeatailsBrief: [''],
            teldeatailsBrief: [''],
            mardeatailsBrief: [''],
            hindiinstruction: [''],
            gujinstruction: [''],
            telinstruction: [''],
            marinstruction: [''],
            hindiNote: [''],
            gujNote: [''],
            telNote: [''],
            marNote: [''],
            bannerVideoLink: [''],
            details_poster: [''],
            details_poster_name: ['']

        });
        this.minEndDate = new Date();
        this.minStartDate = new Date();
        this.startDate.setValue(new Date());
        this.endDate.setValue(new Date());

        if (competitionId != 'new') {
            this.getDraftCompetion(competitionId);
        }

        // this.createCompetitionForm.patchValue({
        //     hindiName: "  ",
        //     gujName: "  ",
        //     telName: "  ",
        //     marName: "  ",
        //     hindideatailsBrief: "  ",
        //     gujdeatailsBrief: "  ",
        //     teldeatailsBrief: "  ",
        //     mardeatailsBrief:"  ",
        //     hindiinstruction: "  ",
        //     gujinstruction: "  ",
        //     telinstruction: "  ",
        //     marinstruction: "  ",
        //     hindiNote: "  ",
        //     gujNote: "  ",
        //     telNote: "  ",
        //     marNote: "  "

        // })

        this.createCompetitionForm.get('level').valueChanges.subscribe(value => {
            if (value === 'State level') {
              this.createCompetitionForm.get('selectedState').setValidators([Validators.required]);
            } else {
              this.createCompetitionForm.get('selectedState').clearValidators();
            }
            this.createCompetitionForm.get('selectedState').updateValueAndValidity();
        });

        this.getAllStates();
    }
    constructor(
        private router: Router,
        private adminService: AdminService,
        private _formBuilder: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private _snackBar: MatSnackBar,
        private _matDialog: MatDialog,
    ) {}
   
    triggerSelectLanguage($event) {
        this.getSelectedLanguageFromFormControl()
    }
    getSelectedLanguageFromFormControl() {
        this.selectedLanguageForShow = this.selectedLanguages.value;
    }
    getErrorName() {
        return this.createCompetitionForm.get('name').hasError('required')
            ? 'Name must be at least 2 characters'
            : this.createCompetitionForm.get('name').hasError('requirements')
                ? 'Name must be at least 2 characters'
                : '';
    }
    getErrorBrief() {
        return this.createCompetitionForm.get('deatailsBrief').hasError('required')
            ? 'Brief cannot be empty'
            : this.createCompetitionForm.get('name').hasError('requirements')
                ? ''
                : '';
    }
    expandField(index) {

        this.toggleExpandIcon[index] = !this.toggleExpandIcon[index];
    }
   changeLanguage(lang){

    this.editingLanguage=lang;

    if(this.editingLanguage=='English*'){
        this.nameForm = 'name';
        this.noteForm = 'note';
        this.instructionForm = 'instruction'
        this.detailForm = 'deatailsBrief'
    }else if(this.editingLanguage == 'हिन्दी'){
        this.nameForm = 'hindiName';
        this.noteForm = 'hindiNote';
        this.instructionForm = 'hindiinstruction'
        this.detailForm = 'hindideatailsBrief'

    }else if(this.editingLanguage == 'ગુજરાતી'){
        this.nameForm = 'gujName';
        this.noteForm = 'gujNote';
        this.instructionForm = 'gujinstruction'
        this.detailForm = 'gujdeatailsBrief'

    }else if(this.editingLanguage == 'తెలుగు'){
        this.nameForm = 'telName';
        this.noteForm = 'telNote';
        this.instructionForm = 'telinstruction'
        this.detailForm = 'teldeatailsBrief'
    } else if(this.editingLanguage == 'मराठी'){
        this.nameForm = 'marName';
        this.noteForm = 'marNote';
        this.instructionForm = 'marinstruction'
        this.detailForm = 'mardeatailsBrief'
    }
    
   }

    getDraftCompetion(competition_uuid) {
        this.adminService.getCompetitionDetails(competition_uuid).subscribe(
            (res) => {
                let details = res.body.competition;
                this.patchValueInForm(details.title.en, details.details.en, details.instructions.en, details.note.en)
            },
            (error) => {
            }
        )

    }
    patchValueInForm(name, deatailsBrief, instruction, note) {
        this.createCompetitionForm.patchValue({
            name: name,
            deatailsBrief: deatailsBrief,
            instruction: instruction,
            note: note
        });
    }
   
    validateUploadImage(file) {
        if (file.size > 1000000) {
            this._snackBar.open("Image is greater than 1MB", 'close', {
                duration: 3000,
                horizontalPosition: this.horizontalPosition,
                verticalPosition: this.verticalPosition,
            });
            return false;
        }
        if (file.type == 'image/jpg' || file.type == 'image/png' || file.type == 'image/jpeg') {
            return true;
        }
        else {
            this._snackBar.open(`Invalid image type ${file.type}`, 'close', {
                duration: 3000,
                horizontalPosition: this.horizontalPosition,
                verticalPosition: this.verticalPosition,
            });
            return false;
        }

    }
    handleLandScapePosterChange(event) {
        this.isUploaded = true;
        const file = event.target.files[0];
        this.fileSize = file.size;
        if (file && this.validateUploadImage(file)) {
            this.adminService.getS3DetailsAndUpload(file, 'poster').subscribe(
                (res) => {
                    this.adminService.uploadImageToS3(file, res).subscribe((res)=>{console.log(res)}, (err)=>{console.log(err)});
                    this.createCompetitionForm.patchValue({
                        poster: res.poster_uuid,
                        posterName: file.name
                    });

                },
                (error) => {
                    this._snackBar.open("Something went Wrong, Upload Failed", 'close', {
                        duration: 3000,
                        horizontalPosition: this.horizontalPosition,
                        verticalPosition: this.verticalPosition,
                    });
                }
            );

            const reader = new FileReader();
            reader.onload = (e: any) => {
                this.posterUrl = e.target.result;
            };
            reader.readAsDataURL(file);
        } else {
            this.posterUrl = '';
        }

    }

    handlePortraitPosterChange(event) {
        this.isPortraitUploaded = true;
        const file = event.target.files[0];
        this.portraitImageSize = file.size;
        if (file && this.validateUploadImage(file)) {
            this.adminService.getS3DetailsAndUpload(file, 'photo').subscribe(
                (res) => {
                    this.adminService.uploadImageToS3(file, res).subscribe((res)=>{console.log(res)}, (err)=>{console.log(err)});
                    this.createCompetitionForm.patchValue({
                        photo: res.photo_uuid,
                        photoName: file.name
                    });
                },
                (error) => {
                    this._snackBar.open("Something went Wrong, Upload Failed", 'close', {
                        duration: 3000,
                        horizontalPosition: this.horizontalPosition,
                        verticalPosition: this.verticalPosition,
                    });
                }
            );
            const reader = new FileReader();
            reader.onload = (e: any) => {
                this.photoUrl = e.target.result;
            };
            reader.readAsDataURL(file);
        } else {
            this.photoUrl = '';
        }
        
    }

    generateRandomString(length) {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let randomString = '';

        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            randomString += characters.charAt(randomIndex);
        }

        return randomString;
    }

    onChangeSlider(event) {
        this.createCompetitionForm.patchValue({
            startClass: this.value,
            endClass: this.highValue
        });

    }
    startTimeTrigger(event) {
        this.createCompetitionForm.patchValue({
            startTime: this.convertDateTimeToISO(this.startDate, this.selectedStartTime),
        });
    }
    onStartDateChange(event) {
        if (this.selectedStartTime) {
            this.createCompetitionForm.patchValue({
                startTime: this.convertDateTimeToISO(this.startDate, this.selectedStartTime),
            });
        }

    }

    onEndDateChange(event) {
        if (this.selectedEndTime) {
            this.createCompetitionForm.patchValue({
                endTime: this.convertDateTimeToISO(this.endDate, this.selectedEndTime),
            });
        }

    }

    endTimeTrigger(event) {
        this.createCompetitionForm.patchValue({
            endTime: this.convertDateTimeToISO(this.endDate, this.selectedEndTime),
        });
    }

    convertDateTimeToISO(selectedDate, time) {
        const dateValue = new Date(selectedDate.value);
        const timeValue = time;
        let [hours, minutes] = timeValue.split(':');
        const isPM = timeValue.toLowerCase().includes('pm');
        if (isPM && hours !== '12') {
            hours = String(parseInt(hours, 10) + 12);
        }
        dateValue.setHours(parseInt(hours, 10), parseInt(minutes, 10));
        const formattedDate = dateValue.toISOString();
        return formattedDate;
    }

    handlePictureChange(event){
        this.isPictureUploaded = true;
        const file = event.target.files[0];
        this.selectedPictureSize = file.size;
        if (file && this.validateUploadImage(file)) {
            this.adminService.getS3DetailsAndUpload(file, 'details-photo').subscribe(
                (res) => {
                    this.adminService.uploadImageToS3(file, res).subscribe((res)=>{console.log(res)}, (err)=>{console.log(err)});
                    this.createCompetitionForm.patchValue({
                        details_poster: res.details_photo_uuid,
                        details_poster_name: file.name
                    });
                },
                (error) => {
                    this._snackBar.open("Something went Wrong, Upload Failed", 'close', {
                        duration: 3000,
                        horizontalPosition: this.horizontalPosition,
                        verticalPosition: this.verticalPosition,
                    });
                }
            );
            const reader = new FileReader();
            reader.onload = (e: any) => {
                this.detailsPicture = e.target.result;
            };
            reader.readAsDataURL(file);
        } 
        else {
            this.detailsPicture = '';
        }

    }



    checkValueForOtherLanguage(){
      if(this.selectedLanguageForShow.includes("हिन्दी")){
        if(!this.createCompetitionForm.get('hindiName').value || this.createCompetitionForm.get('hindiName').value.length < 2 ) return false;
        if(!this.createCompetitionForm.get('hindideatailsBrief').value || this.createCompetitionForm.get('hindideatailsBrief').value.length < 2 ) return false;
        if(!this.createCompetitionForm.get('hindiinstruction').value || this.createCompetitionForm.get('hindiinstruction').value.length < 2 ) return false;
      } 
      if(this.selectedLanguageForShow.includes("ગુજરાતી")){
        if(!this.createCompetitionForm.get('gujName').value || this.createCompetitionForm.get('gujName').value.length < 2 ) return false;
        if(!this.createCompetitionForm.get('gujdeatailsBrief').value || this.createCompetitionForm.get('gujdeatailsBrief').value.length < 2 ) return false; 
        if(!this.createCompetitionForm.get('gujinstruction').value || this.createCompetitionForm.get('gujinstruction').value.length < 2 ) return false;
      } 
      if(this.selectedLanguageForShow.includes("తెలుగు")){
        if(!this.createCompetitionForm.get('telName').value || this.createCompetitionForm.get('telName').value.length < 2 ) return false;
        if(!this.createCompetitionForm.get('teldeatailsBrief').value || this.createCompetitionForm.get('teldeatailsBrief').value.length < 2 ) return false;
        if(!this.createCompetitionForm.get('telinstruction').value || this.createCompetitionForm.get('telinstruction').value.length < 2 ) return false;
      } 
      if(this.selectedLanguageForShow.includes("मराठी")){
        if(!this.createCompetitionForm.get('marName').value || this.createCompetitionForm.get('marName').value.length < 2 ) return false;
        if(!this.createCompetitionForm.get('mardeatailsBrief').value || this.createCompetitionForm.get('mardeatailsBrief').value.length < 2 ) return false;
        if(!this.createCompetitionForm.get('marinstruction').value || this.createCompetitionForm.get('marinstruction').value.length < 2 ) return false;
      }
      return true;
    }

    validateAllField() {
        if (this.createCompetitionForm.valid && this.checkValueForOtherLanguage()) {
            return true;
        }
        else if(this.createCompetitionForm.get('level').value ==='state_level' && this.selectedStateCode!=''){
            return true;
        } 
        else return false;
    }
    onClickPreview(index) {
        this.previewPage = index;
    }


    submitFormData(status) {
        if(!this.validateAllField() && status !== 'DRAFT'){
            this._snackBar.open("Filled all other language", 'close', {
                duration: 3000,
                horizontalPosition: this.horizontalPosition,
                verticalPosition: this.verticalPosition,
            });
            return;
        }

        this.adminService.submitCompetition(this.makeReqBodyForPublishCompetition(status)).subscribe(
            (res) => {
                this._snackBar.open("Publish Successfully", 'close', {
                    duration: 3000,
                    horizontalPosition: this.horizontalPosition,
                    verticalPosition: this.verticalPosition,
                });
                this.router.navigateByUrl('/admin/social-hub/competition-zone');

            },
            (err) => {
                this._snackBar.open("Mandatory Field Must Be Filled Before Save in Draft/Publish", 'close', {
                    duration: 3000,
                    horizontalPosition: this.horizontalPosition,
                    verticalPosition: this.verticalPosition,
                });
            }
        )

    }

    makeReqBodyForPublishCompetition(status) {
        let allowedGrade = [];
        for (let i = this.value; i <= this.highValue; i++) {
            allowedGrade.push(`Class ${i}`);
        }
        let reqBody = {
            title: {
                en: this.createCompetitionForm.get('name').value,
            },
            start_time: this.createCompetitionForm.get('startTime').value,
            end_time: this.createCompetitionForm.get('endTime').value,
            photo: this.createCompetitionForm.get('photo').value,
            poster: this.createCompetitionForm.get('poster').value,
            details: {
                en: this.createCompetitionForm.get('deatailsBrief').value ?? "  ",
            },
            instructions: {
                en: this.createCompetitionForm.get('instruction').value ?? "  ",
            },
            allowed_grades: allowedGrade,
            max_allowed_media : this.numberOfentryForm.value,
            status: status,
            country_code: "IN",
            state_code: null,
            grade: {
                min_allowed_grade: this.value,
                max_allowed_grade: this.highValue
            }

            // level: this.createCompetitionForm.get('level').value
        }
        if(this.createCompetitionForm.get('level').value ==='state_level'){
            reqBody['state_code'] = this.selectedStateCode;
        } 
        if(this.createCompetitionForm.get('details_poster').value){
            reqBody['details_photo'] = this.createCompetitionForm.get('details_poster').value;
        }
        if(this.createCompetitionForm.get('note').value){
            reqBody['note'] = {
                en: this.createCompetitionForm.get('note').value ?? "  ",
            }
        }
        if(this.createCompetitionForm.get('bannerVideoLink').value){
            reqBody['video']={
                url: this.createCompetitionForm.get('bannerVideoLink').value,
                protocol: 'hls'
            }
        }
        if(this.createCompetitionForm.get('hindiName').value && this.createCompetitionForm.get('hindiName').value.length>=2 )
          reqBody['title']['hi'] = this.createCompetitionForm.get('hindiName').value;
        if(this.createCompetitionForm.get('gujName').value && this.createCompetitionForm.get('gujName').value.length>=2 )
          reqBody['title']['gu'] = this.createCompetitionForm.get('gujName').value;
        if(this.createCompetitionForm.get('telName').value && this.createCompetitionForm.get('telName').value.length>=2 )
          reqBody['title']['te'] = this.createCompetitionForm.get('telName').value;
        if(this.createCompetitionForm.get('marName').value && this.createCompetitionForm.get('marName').value.length>=2 )
          reqBody['title']['mr'] = this.createCompetitionForm.get('marName').value;


        if(this.createCompetitionForm.get('hindideatailsBrief').value && this.createCompetitionForm.get('hindideatailsBrief').value.length>=2 )
          reqBody['details']['hi'] = this.createCompetitionForm.get('hindideatailsBrief').value;
        if(this.createCompetitionForm.get('gujdeatailsBrief').value && this.createCompetitionForm.get('gujdeatailsBrief').value.length>=2 )
          reqBody['details']['gu'] = this.createCompetitionForm.get('gujdeatailsBrief').value;
        if(this.createCompetitionForm.get('teldeatailsBrief').value && this.createCompetitionForm.get('teldeatailsBrief').value.length>=2 )
          reqBody['details']['te'] = this.createCompetitionForm.get('teldeatailsBrief').value;
        if(this.createCompetitionForm.get('mardeatailsBrief').value && this.createCompetitionForm.get('mardeatailsBrief').value.length>=2 )
          reqBody['details']['mr'] = this.createCompetitionForm.get('mardeatailsBrief').value;

        if(this.createCompetitionForm.get('hindiinstruction').value && this.createCompetitionForm.get('hindiinstruction').value.length>=2 )
          reqBody['instructions']['hi'] = this.createCompetitionForm.get('hindiinstruction').value;
        if(this.createCompetitionForm.get('gujinstruction').value && this.createCompetitionForm.get('gujinstruction').value.length>=2 )
          reqBody['instructions']['gu'] = this.createCompetitionForm.get('gujinstruction').value;
        if(this.createCompetitionForm.get('telinstruction').value && this.createCompetitionForm.get('telinstruction').value.length>=2 )
          reqBody['instructions']['te'] = this.createCompetitionForm.get('telinstruction').value;
        if(this.createCompetitionForm.get('marinstruction').value && this.createCompetitionForm.get('marinstruction').value.length>=2 )
          reqBody['instructions']['mr'] = this.createCompetitionForm.get('marinstruction').value;

        if(this.createCompetitionForm.get('hindiNote').value && this.createCompetitionForm.get('hindiNote').value.length>=2 )
          reqBody['note']['hi'] = this.createCompetitionForm.get('hindiNote').value;
        if(this.createCompetitionForm.get('gujNote').value && this.createCompetitionForm.get('gujNote').value.length>=2 )
          reqBody['note']['gu'] = this.createCompetitionForm.get('gujNote').value;
        if(this.createCompetitionForm.get('telNote').value && this.createCompetitionForm.get('telNote').value.length>=2 )
          reqBody['note']['te'] = this.createCompetitionForm.get('telNote').value;
        if(this.createCompetitionForm.get('marNote').value && this.createCompetitionForm.get('marNote').value.length>=2 )
          reqBody['note']['mr'] = this.createCompetitionForm.get('marNote').value;
        console.log(reqBody);
        return reqBody;
    }
   removeTags(str) { 
        if ((str===null) || (str==='')) 
            return ""; 
        else
            str = str.toString(); 
        return str.replace( /(<([^>]+)>)/ig, ''); 
    } 
    getlengthOfDetails(){
            let str = this.createCompetitionForm.controls[this.detailForm].value;
            str = this.removeTags(str);
            return str.length;
        
    }
    getlengthOfinstruction(){
        let str = this.createCompetitionForm.controls[this.instructionForm].value;
        str = this.removeTags(str);
        return str.length;
    
}    
    genratePreview(){
        const start_time = new Date(this.createCompetitionForm.get('startTime').value).getTime();
        const end_time = new Date(this.createCompetitionForm.get('endTime').value).getTime();
        const current_time = new Date().getTime();
        if(start_time<current_time){
            this._snackBar.open("start time was already passed", 'close', {
                duration: 3000,
                horizontalPosition: this.horizontalPosition,
                verticalPosition: this.verticalPosition,
            });
            return;
        }
        if(start_time>end_time){
            this._snackBar.open("start time is less than end time", 'close', {
                duration: 3000,
                horizontalPosition: this.horizontalPosition,
                verticalPosition: this.verticalPosition,
            });
            return;
        }
        this.previewDetails = true; 
        this.unsavedChanges = false;
    }

    getAllStates(){
        const country_code = 'IN';
        this.adminService.getAllStates(country_code).subscribe(
            (response) => {
                response.body.data.forEach(state => {
                    this.indianStates.push({
                        code: state.code,
                        name: state.name
                    });
                });
            },
            (error) => {
                console.error(error);
            }
        );
    }

    openPopUp(){
        const dialogRef = this._matDialog.open(DraftDialog, {
            data: {
                submitFormData: this.submitFormData.bind(this)
            }
        });
        dialogRef.afterClosed().subscribe((result) => {
            if(result){
                this.unsavedChanges = false;
            }
            else{
                this.unsavedChanges = true;
            }
        })
    }

}

@Component({
    selector: 'app-draft-dialog',
    templateUrl: 'draft-dialog.html',
    styleUrls: ['./create-competition.component.css']
})

export class DraftDialog{
    constructor(public dialogRef: MatDialogRef<DraftDialog>, @Inject(MAT_DIALOG_DATA) public data: any, private router: Router){

    }
    goTo(){
        this.dialogRef.close(true);
        this.dialogRef.afterClosed().subscribe(() => {
            this.router.navigateByUrl('/admin/social-hub/competition-zone').then(() => {
              console.log('Navigation successful');
            });
        });
    }
    closePopUp(){
        this.router.navigateByUrl('/admin/social-hub/competition-zone/competition/create-competition/new/edit').then(() =>{
            this.dialogRef.close(false);
        })
    }
    saveAsDraft(){
        this.data.submitFormData('DRAFT');
        this.dialogRef.close(true);
    }
}